"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var React = require("react");
var GoogleMapContext_1 = require("../context/GoogleMapContext");
var GoogleMapInstance_1 = require("./GoogleMapInstance");
var googleMap = function (props) {
    var _a = React.useState(null), map = _a[0], setMap = _a[1];
    var _b = React.useState(props), mapState = _b[0], setMapState = _b[1];
    var _c = React.useState(props.children), children = _c[0], setChildren = _c[1];
    var _d = React.useState(props.zoom), zoom = _d[0], setZoom = _d[1];
    var _e = React.useState(null), bound = _e[0], setBound = _e[1];
    var _f = React.useState(mapState.center), center = _f[0], setCenter = _f[1];
    var store = {
        map: map,
        setMap: setMap,
        mapState: mapState,
        setMapState: setMapState,
        children: children,
        setChildren: setChildren,
        zoom: zoom,
        setZoom: setZoom,
        bound: bound,
        setBound: setBound,
        center: center,
        setCenter: setCenter
    };
    return (React.createElement(GoogleMapContext_1.GoogleMapContext.Provider, { value: store },
        React.createElement(GoogleMapInstance_1.GoogelMapInstance, __assign({}, props))));
};
exports.GoogleMap = googleMap;
